export default async () => {
	$( '.js-language-toggle' ).click( function ( e ) {
		e.preventDefault();
		$( this ).next().slideToggle();
		$( this ).toggleClass( 'is-active' );
	} );

	$( '.js-menu-toggle' ).click( function ( e ) {
		e.preventDefault();
		$( this ).toggleClass( 'is-active' );
		$( 'body, html, .header__menu' ).toggleClass( 'is-active' );
		$( '.floating-link' ).toggleClass( 'is-menu' );
	} );

	$( '.header__menu .has-chiliden > a' ).click( function ( e ) {
		e.preventDefault();
		$( this ).next( 'ul' ).slideToggle( 'fast' );
	} );
};
